import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';

import {ConfirmationService, SelectItem} from 'primeng/api';

import {EventService, FileHelperService} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';
import {User, UserRole} from '../../../../core/models';
import {UserService} from '../../../../core/services';
import {TopbarService} from '../../../../topbar.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PasswordPolicyValidator} from '../../../../shared/password-policy.validator';
import {MustMatchValidator} from '../../../../shared/must-match.validator';
import {MustNotMatchValidator} from "../../../../shared/must-not-match.validator";

@Component({
  selector: 'app-user-details-edit',
  templateUrl: './user-details-edit.component.html',
  styleUrls: ['./user-details-edit.component.scss']
})
export class UserDetailsEditComponent implements OnInit {
  @Input() user: User;
  form: FormGroup;
  userOrig: User;
  saving = false;
  changes = false;
  authUser: AuthUser = this.token.whoAmI();
  availableUserRolesSelect: SelectItem[] = [{label: 'Select Role', value: null}];
  availableUserRoles: UserRole[];

  constructor(
    private router: Router,
    private token: TokenService,
    private confirmationService: ConfirmationService,
    private eventService: EventService,
    private userService: UserService,
    private fileHelperService: FileHelperService,
    private topbarService: TopbarService,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit() {
    this.userOrig = this.user;
    if (this.authUser.hasAnyRole(['AC_MANAGE_USER'])) {
      this.userService.getAvailableRoles().subscribe(
        (data) => {
          this.availableUserRoles = data;
          data.forEach((role) => this.availableUserRolesSelect.push({label: role.name, value: role.name}));
          this.loadForm(this.user);
        }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadForm(this.user);
  }

  loadForm(user: User) {
    if (user) {
      this.form = this.formBuilder.group({
        userName: [user.name, Validators.required],
        userEmail: [user.email, [Validators.required, Validators.email]],
        password: ['', [PasswordPolicyValidator]],
        confirmPassword: [''],
        selectedUserRole: [user.userRole.name, [Validators.required]]
      }, {
        validators: [
          MustMatchValidator('password', 'confirmPassword'),
          MustNotMatchValidator('password', ['userName', 'userEmail'], null)]
      });
    }
  }

  backToList() {
    this.router.navigate(['/admin', 'user', 'list']);
  }

  saveUser() {
    this.saving = true;
    this.updateUser();
  }

  updateUser() {
    this.saving = true;

    this.user.name = this.form.value.userName;
    this.user.email = this.form.value.userEmail;
    this.user.password = null;
    this.user.userRole = {} as UserRole;
    this.user.userRole.name = this.form.controls.selectedUserRole.value;

    this.userService.update(this.user)
      .subscribe(
        (data) => {
          if (this.user.email === this.authUser.sub) {
            this.topbarService.setAvatarItems(data);
          }
          this.backToList();
          delete (this.changes);
          delete (this.saving);
        },
        (error) => {
          delete (this.saving);
          delete (this.changes);
        }
      );
  }

  confirm() {
    if (this.authUser.hasRole('AC_MANAGE_USER')) {
      this.confirmationService.confirm({
        message: (this.user.status === 'A')
          ? 'Are you sure that you want to deactivate this user?'
          : 'Are you sure that you want to activate this user?',
        accept: () => {
          this.toggle(this.user);
        }
      });
    }
  }

  toggle(user?: User) {
    this.toggleUserStatus(this.user);

    // this.saving = true;
    // this.userService.update(this.userOrig).subscribe(
    //     (data) => { this.user = this.userOrig; },
    //     (error) => { delete (this.saving); }
    // );
  }

  toggleUserStatus(user: User) {
    if (user.status === 'A') {
      user.status = 'I';
    } else {
      user.status = 'A';
    }
    this.changes = true;
  }

  removeImage() {
    delete (this.user.image);
  }

  storeFile(event, element) {
    const file = event.files[0];
    if (!file.type.startsWith('image/')) {
      this.eventService.warn('invalid content, please uplaod an image');
      element.clear();
      return;
    }
    this.fileHelperService.fileToDataUrl(file, (data) => {
      this.user.image = data;
    });
  }
}
